import React, { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";
import NuAmount from "../../../../../Components/Utils/NuAmount";

function OrdersRecordProDash() {
  const [params, setParams] = useState({ period: "monthly" });
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");
  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/QuotesSubmittedByProcurementRecords`, params);

  const periods = [
    { value: "monthly", option: "Monthly" },
    { value: "quarterly", option: "Quarterly" },
    { value: "halfyearly", option: "Half Yearly" },
    { value: "yearly", option: "Yearly" },
  ];

  const hanChange = (e) => {
    setParams({ period: e.target.value });
    setSelectedPeriod(e.target.value);
  };

  const dataDummy = (data?.customer_request_salesman_wise || []).map((item) => ({
    name: item.procurementMember || "N/A",
    amount: item.price || 0,
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-gray-900 text-white shadow-xl rounded-xl p-3 text-xs border border-gray-700">
          <p className="font-semibold text-gray-300 mb-1">{label}</p>
          <p className="text-emerald-400 font-bold">
            Order Value: <NuAmount value={payload[0].value} />
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Procurement Member Order Values</h3>
        </div>

        <select
          value={selectedPeriod}
          onChange={hanChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none"
        >
          {periods.map((period) => (
            <option key={period.value} value={period.value}>
              {period.option}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-56 flex items-center justify-center animate-pulse">
          <div className="h-36 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="h-56 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              layout="vertical"
              data={dataDummy}
              margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
              barSize={14}
            >
              <XAxis type="number" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: "#6B7280" }} />
              <YAxis type="category" dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: "#6B7280" }} width={80} />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(243, 244, 246, 0.6)" }} />
              <Bar dataKey="amount" fill="#3B82F6" radius={[0, 6, 6, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}

export default OrdersRecordProDash;
